import { z } from 'zod'

// The two login areas. Neither has an account: the address is only asked for, and a fresh link
// goes out if the database knows it (S0-014, owner decision 2026-10-20).
export const loginRoles = ['booker', 'ensemble'] as const
export type LoginRole = (typeof loginRoles)[number]

export const loginRequestSchema = z.object({
  email: z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z.email('Diese E-Mail-Adresse sieht nicht gültig aus.'))
    .pipe(z.string().max(320)),
  role: z.enum(loginRoles),
})
export type LoginRequest = z.infer<typeof loginRequestSchema>
